// Bulk-Aktionen: show each action's settings only while its checkbox is on.
// Each toggle checkbox carries `data-bulk-target="<key>"`; its settings live in
// a CompositeField wrapper with the class `bulk-options--<key>`.
function initBulkToggles() {
    const toggles = document.querySelectorAll('[data-bulk-target]');
    toggles.forEach((checkbox) => {
        const key = checkbox.getAttribute('data-bulk-target');
        const group = document.querySelector('.bulk-options--' + key);
        if (!group) {
            return;
        }
        const sync = () => {
            group.hidden = !checkbox.checked;
        };
        checkbox.addEventListener('change', sync);
        sync();
    });
}

document.addEventListener('DOMContentLoaded', initBulkToggles);
